import React from 'react';
export const FindTeachers = () => {
  return <div className="min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] p-8" data-id="element-3878">
      <div className="max-w-7xl mx-auto" data-id="element-3879">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-12 text-center border border-white/10" data-id="element-3880">
          <h1 className="text-3xl font-serif font-bold text-white mb-4" data-id="element-3881">
            Find Teachers
          </h1>
          <p className="text-gray-300 text-lg" data-id="element-3882">Coming Soon</p>
        </div>
      </div>
    </div>;
};